import Button from "@Components/Button";

import styles from "./TicketsChat.module.scss";

export default function CloseChatDialog({
  open,
  setOpen,
  handleResetState,
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleResetState: () => void;
}) {
  const handleHideDialog = () => {
    setOpen(false);
  };

  return open ? (
    <>
      <dialog
        id="close-dialog"
        data-testid="dialog"
        className={styles.closeDialogContainer}
        open={true}
      >
        <div className={styles.header}>Warning</div>

        <div className={styles.closeDialogContent}>
          Closing this window will result in the loss of unsaved changes. Do you
          wish to save your changes?
        </div>
        <div className={styles.closeDialogButtons}>
          <Button
            className={styles.closeDialogButton}
            onClick={() => {
              handleHideDialog();
              handleResetState();
            }}
            variant="pink"
          >
            Discard Changes & Close
          </Button>
          <Button
            className={styles.closeDialogButton}
            onClick={() => {
              handleHideDialog();
            }}
            variant="blue"
          >
            Save
          </Button>
        </div>
      </dialog>
    </>
  ) : null;
}
